// extracted by mini-css-extract-plugin
export default {"container":"ViewImage_container__BYdXI","img_container":"ViewImage_img_container__Abf7q","title":"ViewImage_title__Ffc2x"};